'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright 2013-2015, Hudl
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LICENSE file in the root directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @providesModule VideoState
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _immutable = require('immutable');

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _deprecationWarning = require('../deprecationWarning');

var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);

var _StateSnapshot = require('./StateSnapshot');

var _StateSnapshot2 = _interopRequireDefault(_StateSnapshot);

var _store = require('../../store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _cache = {};
var MS_TO_S = 1000;
// not sure why eslint thinks this should be a const
var DEFAULT_STATE_KEYS = void 0; // eslint-disable-line prefer-const
var _state = {};
var _snapshotCache = {};
var defaultVideoObject = {
  _uninitiated: true,
  currentTime: 0,
  duration: 0,
  muted: false
};

// TODO: Add tests around this
function getLegacyPlayer() {
  var store = _store2.default.storeInstance();
  if (store.initialized === false) {
    return defaultVideoObject;
  }
  var players = store.getState().players;
  var keys = Object.keys(players || {});
  if (keys.length) {
    return _store2.default.getPlayerInstance([keys[0]]) || defaultVideoObject;
  }
  return defaultVideoObject;
}

var _defaults = {
  state: function state() {
    return (0, _objectAssign2.default)({}, {
      _internalShouldResume: true,
      autoAdvance: true,
      autoPlay: false,
      canPlay: false,
      continuous: false,
      currentQuality: new _immutable.Map(),
      contextMenuOpen: false,
      fullscreen: false,
      focused: true,
      isSeeking: false,
      loop: new _immutable.Map({
        isLooping: false,
        startTimeMs: null,
        endTimeMs: null
      }),
      loading: false,
      muted: false,
      paused: true,
      playables: (0, _immutable.List)([]),
      playbackRate: 1,
      queueEnded: false,
      qualities: (0, _immutable.List)([]),
      qualityChangeLoading: true,
      viNode: '',
      volume: 1
    });
  }
};

var setupProperty = function setupProperty(self, propName) {
  Object.defineProperty(self, propName, {
    get: function get() {
      return self.get(propName);
    },
    configurable: true
  });
};

var initializeProperties = function initializeProperties(self, values) {
  self._map = new _immutable.Map((0, _immutable.fromJS)(values));
  self._playingIndex = 0;
  self._currentTimeMs = 0;
  Object.keys(values).forEach(function (name) {
    setupProperty(self, name);
  });
};

var State = function () {
  function State() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _defaults.state();

    _classCallCheck(this, State);

    initializeProperties(this, values);
    this.generateSnapshot = this.generateSnapshot.bind(this);
    this.getCachedSnapshot = this.getCachedSnapshot.bind(this);
    this.resetState = this.resetState.bind(this);
    this.generateSnapshot();
  }

  /**
  * Used for bulk changing state. We use the Immutable `withMutations` function
  * to reduce performance overhead
  *
  * @param {Object} updateObject - The updateObject to apply to our state
  */


  _createClass(State, [{
    key: 'withMutations',
    value: function withMutations(updateObject) {
      this._map = this._map.withMutations(function (map) {
        var keys = Object.keys(updateObject);
        var innerMap = map;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            innerMap.set(key, updateObject[key]);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }

    /**
    * Converts the entire state object into raw javascript
    *
    * @returns {Object} - The immutable state as a plain JS Object , merged with our computed properties
    */

  }, {
    key: 'toJS',
    value: function toJS() {
      var jsObject = this._map.toJS();
      jsObject.currentTime = this.currentTimeMs / 1000;
      jsObject.currentTimeMs = this._currentTimeMs;
      jsObject.playingIndex = this._playingIndex;
      jsObject.duration = this.duration;
      jsObject.durationMs = this.durationMs;
      jsObject.src = this.src;
      return jsObject;
    }

    /**
     * Resets properties to an empty state and clears cache
     */

  }, {
    key: 'resetState',
    value: function resetState() {
      initializeProperties(this, _defaults.state());
    }

    /**
    * Checks if a key exists within the Immutable Map
    *
    * @private
    * @param {String} key - to check against
    * @returns {Boolean} - Whether the key exists
    */

  }, {
    key: 'has',
    value: function has(key) {
      return this._map.has(key);
    }

    /**
    * Gets a value from the immutable map, or returns the specified default value
    *
    * @param {String} key - to access
    * @param {any} defaultVal - value to use if key not found
    * @returns {any} - the value associated with the key
    */

  }, {
    key: 'get',
    value: function get(key, defaultVal) {
      if (!this.has(key)) {
        return defaultVal;
      }
      var result = this._map.get(key, defaultVal);
      if (result !== null && (typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object' && result.toJS) {
        return result.toJS();
      }
      return result;
    }

    /**
    * Gets the raw immutable value from a map, or returns the specified default value
    *
    * @param {String} key - to access
    * @param {any} defaultVal - value to use if key not found
    *
    * @returns {any} - rather the Immutable object or the primitive associated with the key
    */

  }, {
    key: 'getImmutable',
    value: function getImmutable(key, defaultVal) {
      if (!this.has(key)) {
        return defaultVal;
      }
      return this._map.get(key, defaultVal);
    }

    /**
    * Sets a value on the immutable map against the specified key
    *
    * @private
    * @param {String} key - to set the value against
    * @param {any} value - to be set
    * @returns {this} - returns the `this` context
    * @throws Map not initialised
    */

  }, {
    key: '_set',
    value: function _set(key, value) {
      if (!this._map) {
        throw new Error('Map not initialised');
      }
      var exists = this._map.has(key);
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !value.toJS) {
        this._map = this._map.set(key, (0, _immutable.fromJS)(value));
      } else {
        this._map = this._map.set(key, value);
      }
      if (!exists) {
        setupProperty(this, key);
        return this;
      }
      return this;
    }

    /**
    * Removes a key value pair from the immutable param
    *
    * @private
    * @param {String} key - to be removed
    * @returns {this} - returns the `this` context
    * @throws Error - Remove forbidden key
    * @throws Error - Remove non-existent key
    */

  }, {
    key: '_remove',
    value: function _remove(key) {
      if (DEFAULT_STATE_KEYS.indexOf(key) !== -1) {
        throw new Error('You attempted to remove ' + key + ' from the state however this is a\n        DEFAULT STATE KEY. This is forbidden');
      }
      if (!this.has(key)) {
        throw new Error('You attempted to remove ' + key + ' from the State yet it didn\'t exist');
      }
      if (_cache[key]) {
        delete _cache[key];
      }
      this._map = this._map.remove(key);
      return this._map;
    }

    /*
     * @deprecate in 3.0.0
     */

  }, {
    key: 'insertPlaylistItem',
    value: function insertPlaylistItem(index, playlistItem) {
      return getLegacyPlayer().insertPlaylistItem(index, playlistItem);
    }
  }, {
    key: 'removePlaylistItem',
    value: function removePlaylistItem(index) {
      return getLegacyPlayer().removePlaylistItem(index);
    }
  }, {
    key: 'getCachedSnapshot',


    /**
    * Returns the cached snapshot, and if there isn't one, generate it.
    *
    * @returns { StateSnapshot } - The cached snapshot
    */
    value: function getCachedSnapshot() {
      if (_snapshotCache) {
        return _snapshotCache;
      }
      return this.generateSnapshot();
    }

    /**
    * Generates a snapshot of the current state and if necessary stores it in the cache
    *
    * @param { boolean } cache - whether or not to cache the snapshot
    * @returns { StateSnapshot } - The generated snapshot
    */

  }, {
    key: 'generateSnapshot',
    value: function generateSnapshot() {
      var cache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var snap = new _StateSnapshot2.default(this);
      if (cache) {
        _snapshotCache = snap;
        return _snapshotCache;
      }
      _snapshotCache = undefined;
      return snap;
    }
  }, {
    key: 'currentTime',
    get: function get() {
      (0, _deprecationWarning2.default)('state.currentTime is renamed to state.currentTimeMs.');
      return this.currentTimeMs / MS_TO_S;
    },


    /*
     * @deprecate in 3.0.0
     */
    set: function set(time) {
      (0, _deprecationWarning2.default)('state.currentTime is renamed to state.currentTimeMs.');
      this._currentTimeMs = time * MS_TO_S;
      return this._currentTimeMs;
    }
  }, {
    key: 'currentTimeMs',
    get: function get() {
      return getLegacyPlayer().currentTime * 1000;
    }

    /*
     * @deprecate in 3.0.0
     */
    ,
    set: function set(time) {
      this._currentTimeMs = time;
      return this._currentTimeMs;
    }
  }, {
    key: 'duration',
    get: function get() {
      (0, _deprecationWarning2.default)('state.duration is renamed to state.durationMs.');
      return this.durationMs / MS_TO_S;
    }
  }, {
    key: 'durationMs',
    get: function get() {
      if (!this.continuous) {
        if (getLegacyPlayer().duration) {
          return getLegacyPlayer().duration * MS_TO_S;
        }
        var playable = this.playables[this.playingIndex];
        if (playable) {
          // @deprecate 3.0.0 `playable.duration`
          playable.durationMs = playable.durationMs || playable.duration * MS_TO_S;
          return playable.durationMs || playable.endTimeMs - playable.startTimeMs;
        }
        return 0;
      }

      return this.playables.reduce(
      // @deprecate 3.0.0 `playable.duration`
      function (dur, playable) {
        return dur + (playable.durationMs || playable.duration * MS_TO_S);
      }, 0);
    }
  }, {
    key: 'virtualCurrentTime',
    get: function get() {
      (0, _deprecationWarning2.default)('state.virtualCurrentTime is renamed to state.virtualCurrentTimeMs.');
      return this.virtualCurrentTimeMs / MS_TO_S;
    }
  }, {
    key: 'virtualCurrentTimeMs',
    get: function get() {
      var _this = this;

      if (!this.continuous) {
        return this.currentTimeMs;
      }

      var playablesPlayedArray = new Array(this.playingIndex).fill(1);

      var playablesPlayedDuration = playablesPlayedArray.reduce(function (prev, curr, i) {
        return prev + (
        /*
         * @deprecation-compat
         * Support both .durationMs and .duration in v2.0.0
         * Remove in v3.0.0
         */
        _this.playables[i].durationMs || _this.playables[i].duration * MS_TO_S);
      }, 0);

      return playablesPlayedDuration + this.currentTimeMs;
    }
  }, {
    key: 'isLooping',
    get: function get() {
      (0, _deprecationWarning2.default)('state.isLooping is moved to state.loop.isLooping.');

      return this._map.get('loop').get('isLooping');
    },
    set: function set(isLooping) {
      (0, _deprecationWarning2.default)('state.isLooping is moved to state.loop.isLooping.');
      var loop = this._map.get('loop').toJS();
      loop.isLooping = isLooping;
      this._map = this._map.set('loop', (0, _immutable.fromJS)(loop));
      return isLooping;
    }
  }, {
    key: 'src',
    get: function get() {
      var playable = this.playables[this.playingIndex];
      return playable ? playable.src : ''; // support async loading
    }
  }, {
    key: 'playingIndex',
    get: function get() {
      return this._playingIndex;
    },
    set: function set(index) {
      this._playingIndex = index;
    }
  }]);

  return State;
}();

_state = new State();
DEFAULT_STATE_KEYS = Object.keys(_state.toJS());
DEFAULT_STATE_KEYS.push(['currentTime', 'currentTimeMs', 'duration', 'durationMs', 'playingIndex', 'src', 'virtualCurrentTime', 'virtualCurrentTimeMs']);

exports.default = {
  get state() {
    return _state.getCachedSnapshot();
  },
  generateSnapshot: _state.generateSnapshot,
  getCachedSnapshot: _state.getCachedSnapshot,
  insertPlaylistItem: _state.insertPlaylistItem,
  removePlaylistItem: _state.removePlaylistItem,
  setBulkState: function setBulkState(updateStateObject) {
    _state.withMutations(updateStateObject);
  },
  setState: function setState(key, value) {
    switch (key) {
      case 'currentTime':
        _state.currentTime = value;
        break;
      case 'currentTimeMs':
        _state.currentTimeMs = value;
        break;
      case 'playingIndex':
        _state.playingIndex = value;
        break;
      case 'src':
        _state.src = value;
        break;
      default:
        _state = _state._set(key, value);
    }
  },
  deleteRootFromState: function deleteRootFromState(root) {
    if (DEFAULT_STATE_KEYS.indexOf(root) === -1) {
      _state._remove(root);
      delete _state.root;
    }
  },

  resetState: _state.resetState,
  rawState: _state
};
module.exports = exports['default'];